import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { Doc, ListMethodArg, ListMethodResponse, GetMethodResponse, ModelClass, References } from '/imports/types';

export interface CardName extends Doc {
  _id: string;
  name: string;
}

type Model = CardName;
type Refs = References<Model>;

export const CardNames = new Mongo.Collection<CardName>('cardNames');

export const listCardNames = DeclareMethod<ListMethodArg<CardName>, ListMethodResponse<CardName, Refs>>('listCardNames');
export const getCardName = DeclareMethod<string, GetMethodResponse<CardName, Refs>>('getCardName');
export const createCardName = DeclareMethod<Partial<CardName>, string>('createCardName');
export const updateCardName = DeclareMethod<Partial<CardName>, string>('updateCardName');
export const deleteCardName = DeclareMethod<string, undefined>('deleteCardName');

export const modelClass: ModelClass<Model, Refs> = {
  collection: CardNames,
  editableFields: ['name'],
  listMethod: listCardNames,
  getMethod: getCardName,
  createMethod: createCardName,
  updateMethod: updateCardName,
  deleteMethod: deleteCardName,
  pathPrefix: '/card-names',
  modelName: 'Card Name',
  pluralName: 'Card Names',
};
